"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCartesianPlotCtor = void 0;
const rc_js_util_1 = require("rc-js-util");
const entity_category2d_1 = require("../update/update-group/entity-category2d");
const core_1 = require("@visualization-tools/core");
/**
 * @public
 * Generates the constructor of {@link ICartesian2dPlot}. Use a factory to create an instance ({@link CanvasCartesian2dPlotFactory},
 * {@link GlCartesian2dPlotFactory} etc) unless extending.
 */
function createCartesianPlotCtor(axisFactory, metaUpdateHooks, dataUpdateHooks) {
    var _a;
    return _a = class CartesianPlot extends core_1.Plot {
            constructor(arg) {
                super(arg);
                this.plotListeners = new rc_js_util_1.TemporaryListener();
                const ctor = this.constructor;
                this.updateArgProvider = arg.plotOptions.updateGroup.updateArgProvider;
                this.metaCategory = new entity_category2d_1.EntityCategory2d(this, arg.chart.renderer, arg.plotOptions.updateGroup, ctor.metaUpdateHooks);
                this.dataCategory = new entity_category2d_1.EntityCategory2d(this, arg.chart.renderer, arg.plotOptions.updateGroup, ctor.dataUpdateHooks);
                this.configureDefaults(arg.plotOptions, arg.chart);
                this.registerEventHandlers(arg.plotOptions);
            }
            configureDefaults(options, chartComponent) {
                if (options.useDefaultAxis) {
                    this.constructor.axisFactory.setDefaultAxis(this, options, chartComponent);
                }
            }
            registerEventHandlers(options) {
                core_1.OnPlotAttachChanged.registerListener(this, (isAttached) => {
                    if (!isAttached) {
                        this.plotListeners.clearingEmit();
                    }
                });
                this.plotListeners.addListener(core_1.OnCanvasResized.registerListener(this.eventService, () => {
                    this.setPlotArea(options.getPlotArea(this.attachPoint));
                }));
                this.plotListeners.addListener(core_1.OnDprChanged.registerListener(this.eventService, (dpr) => {
                    options.axisConfig.regenerate(dpr);
                }));
            }
        },
        _a.axisFactory = axisFactory,
        _a.metaUpdateHooks = metaUpdateHooks,
        _a.dataUpdateHooks = dataUpdateHooks,
        _a;
}
exports.createCartesianPlotCtor = createCartesianPlotCtor;
//# sourceMappingURL=create-cartesian-plot-ctor.js.map